import React from "react";


class ENSubmission extends React.Component{
    render(){
return(
    <div className="EN">
    <h3>轴音旋律-AnXiens- 2025 Open Submission event starts now!</h3>
    <p>
        Submission Requirement:
    </p><p>
- You must own the full copyright of your submitted work.
</p><p>
- Track length must be between 1:50 - 2:20
</p><p>
- Your submissions must be original songs that have not been released before the deadline.
</p><p>
- Songs can include appropriate lyrics. (Languages are unlimited.) If your work contains lyrics, please provide the original lyrics when submitting your work.
</p><p>
- Each participant can submit up to 3 tracks, participating in a collaborative song will count towards individual submission limit.
</p><p>
- You should be at least 18 years of age (at the time of submission) or else require a legal guardian to sign for you.
</p><p>
</p><p>
Failing to comply with the above rules may disqualify your submitted work.
</p><br/>
<p>
After Submitting:
</p><p>
- We will send you a confirmation email within 7 business days after receiving your submission.
</p><p>
- All submitted works will only be used for the event and will be kept strictly confidential by GLACIA STUDIO.
</p><p>
- We will review all submissions received and select some of them for in-game use. The total number of songs selected will be determined by GLACIA STUDIO.
</p><p>
- We will not publish or use any submitted song that is not selected.
</p><p>
- We will contact the winners before the review deadline. Releasing your submitted work before the deadline will be automatically counted as disqualified.
</p><p>
- If we haven't contacted you after the event ends, you can then publish your submitted work.
</p><br/>
<p>
About Copyright & Contract:
</p><p>
- You still owns the copyright of your submitted work, until we contact you and sign a contract to purchase the copyright.
</p><p>
- After your work is selected, we will sign a contract with you, and will pay a license fee for ownership of the song.
</p><p>
- We will keep all personal information you provide strictly confidential and will only use it for contract & review purposes.
</p><p>
Submission Deadline: July 1, 2025
</p><p>
Review Deadline: July 30, 2025
</p><br/>
<p>
Please provide your info according to the following formats:
</p><p>
1. Your legal name
</p><p>
2. Your contact details (E-mail)
</p><p>
3. Your artist name (your name displayed in-game, list all members here if you're submitting as a team.)
</p><p>
4. Song title
</p><p>
5. Song tempo; please provide additional info if your work includes tempo changes (mark in milliseconds or meter)
</p><p>
6. A brief description of your work and lyrics, if available.
</p><p>
7. An audio file (48kHz, 24bit), the name format must be: 2025AXSubmission_[SongTitle].wav
</p><p>

GLACIA STUDIO reserves the final right for this event. If you have any questions, please contact this email: <a href="https://www.anxiens.com/event/songsubmission2025/">glacia_studio@foxmail.com</a>
</p><br/><br/>
    </div>
    )
    }
    }

export default ENSubmission